export default "__VITE_ASSET__BJLhsVm___"